import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import type { FilterSummaryLine } from "app/pages/sales-intelligence/modules/leads-search-filters/utils/buildLeadsFilterChips";

type TeamFiltersTooltipContentProps = {
    lines: readonly FilterSummaryLine[];
    title?: string;
    dataAutomation: string;
};

const MAX_LIST_HEIGHT = "400px";

/** Tooltip body listing a team's configured filters as "<Filter name>: <values>" rows. */
export const TeamFiltersTooltipContent = ({ lines, title, dataAutomation }: TeamFiltersTooltipContentProps) => {
    return (
        <Stack
            gap="2px"
            maxWidth="280px"
            data-automation={dataAutomation}
        >
            {title ? (
                <Text
                    fontVariant="listItem1"
                    color={colorsPalettes.carbon[0]}
                    padding="0 0 6px 0"
                >
                    {title}
                </Text>
            ) : null}
            <Stack
                gap="2px"
                maxHeight={MAX_LIST_HEIGHT}
                overflow="auto"
                data-automation={`${dataAutomation}-list`}
            >
                {lines.map((line) => (
                    <Text
                        key={line.id}
                        fontVariant="tooltip"
                        color={colorsPalettes.carbon[0]}
                    >
                        <Text
                            as="span"
                            fontVariant="listItem4"
                            color={colorsPalettes.carbon[0]}
                        >
                            {line.name}
                        </Text>
                        {line.value ? `: ${line.value}` : ""}
                    </Text>
                ))}
            </Stack>
        </Stack>
    );
};
